<template>
<v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
        <v-col cols="12">
            <i-card-vertical headerTitle="91.1 Paint Specification">
                <template v-slot:body>
                    <v-layout column overflow-auto>
                        <v-row dense>
                            <v-col cols="12" class="pa-0">
                                <i-card-top class="d-md-flex" outlined :useBtnList="[
                                    'btnRetrieve', //Retrieve
                                ]" @btnRetrieve="doSearchMain()">
                                    <template v-slot:body>
                                        <v-layout column>
                                            <v-row no-gutters class="center pa-2 pb-0">                                                
                                               <v-icon small color="blue" >mdi-circle</v-icon>
                                               <span class="pa-1 subTitle"> Ship no : </span>
                                               <v-col cols="1">
                                                <v-select
                                                    v-model="selectedShip"
                                                    :items="shipNoList"
                                                    item-value="selectedShip"                                                
                                                    label=""
                                                    return-object
                                                    single-line                                                    
                                                    outlined
                                                    dense
                                                    @change="shipNoChange"
                                                ></v-select>
                                                </v-col>
                                                <v-icon small color="blue" class="pl-2" >mdi-circle</v-icon>
                                                <span class="pa-1 subTitle"> Paint Code : </span>
                                                <v-col cols="1">
                                                    <v-text-field class="popField" dense outlined hide-details="auto" clearable maxLength="10" v-model="pntCd"
                                                    @keydown.enter="doSearchMain()" />
                                                </v-col>
                                            </v-row>
                                        </v-layout>
                                    </template>
                                </i-card-top>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" class="pa-0">
                                <v-row no-gutters>
                                    <v-col cols="12" align="right" class="pr-2 customer">(Included V.A.T)</v-col>
                                </v-row>
                                <DxDataGrid id="epms9000paint" class="listBox" :ref="epms9000paintRef" :data-source="gridMainList"
                                    :remote-operations="false" :hover-state-enabled="true" :allow-column-resizing="true"
                                    :allow-column-reordering="true" :row-alternation-enabled="true" :show-borders="true"
                                    :width="grid.width" :show-row-lines="true" key-expr="id" :focused-row-enabled="true"
                                    :column-hiding-enabled="false" :selection="{ mode: 'none' }" >
                                    <DxColumn data-field="" caption="No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center" cell-template="rowNo"/>
                                    <template #rowNo="{ data }">
                                        <div> {{data.component.pageIndex() * data.component.pageSize() + data.rowIndex + 1}} </div>
                                    </template>
                                    <DxColumn data-field="pntCd" caption="Painting Code" width="7%"
                                        data-type="string" :allow-editing="false" alignment="center" :visible="true"
                                        header-cell-template="pntCode" />
                                    <template #pntCode>
                                        <div>Painting<br />Code</div>
                                    </template>
                                    <DxColumn caption="Painting Spec" width="50%" data-type="string" :allow-editing="false"
                                        alignment="center">
                                        <DxColumn data-field="coatNo" caption="Coat No" width="5%" data-type="string"
                                            :allow-editing="false" alignment="center" />
                                        <DxColumn data-field="matlCd" caption="Code" width="15%" data-type="string" :allow-editing="false"
                                            alignment="center" />
                                        <DxColumn data-field="matlSpec" caption="Painting Product" width="20%" data-type="string" :allow-editing="false" alignment="left" />
                                        <DxColumn data-field="svr" caption="SVR" width="5%" data-type="string" :allow-editing="false"
                                            alignment="center" />
                                        <DxColumn data-field="dft" caption="DFT" width="5%" data-type="string" :allow-editing="false" alignment="center" />
                                    </DxColumn>
                                    <DxColumn caption="Thinner" width="30%" data-type="string" :allow-editing="false" alignment="center">
                                        <DxColumn data-field="thinNo" caption="Thin. No" width="10%" data-type="string" :allow-editing="false"
                                            alignment="center" />
                                        <DxColumn data-field="thinSpec" caption="Thin Spec." width="20%" data-type="string" :allow-editing="false"
                                            alignment="left" />                                       
                                    </DxColumn>
                                    <DxColumn data-field="surfMatl" caption="Surf. Material" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center" />
                                    <DxColumn data-field="makerNm" caption="Maker" width="10%" data-type="string" :allow-editing="false"
                                        alignment="center" />
                                                                                                           
                                    <DxPaging :enabled="true" :page-size="30" />
                                </DxDataGrid>
                            </v-col>
                        </v-row>
                    </v-layout>
                </template>
            </i-card-vertical>
        </v-col>
    </v-row>
</v-container>
</template>

<script>

import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { epms9000paint } from '@/api/view/hip/91/epms9000_paint.js'
import { getShipNoList1 } from '@/api/view/hip/common/common.js'
import { getDateFormat } from '@/utils/common.js'
import { parseNumber } from 'devextreme/localization'
import { getNumComma } from '@/utils/common.js'

export default {
     name: 'epms9000paint',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop
    },
    data() {
        return {
            gridMainList: [],
            epms9000paintRef: "epms9000paintRef",
            selectedShip: null,
            shipNoList:[],

            pntCd:""
        }
    },    
    watch: {
        pntCd(val) {
            this.pntCd = val.toUpperCase()
        }
    },
    methods: {
        shipNoChange(e) {
                
            this.doSearchMain()
        },
        async doSearchMain() {
            
            this.openLoading('searching')
            let params = {
                shipNo: this.selectedShip,
                pntCd: this.pntCd
            }

            await epms9000paint(params).then(res => {
                this.gridMainList = res.list
               
            }).finally(() => {
                //console.log(this.gridMainList);
                this.endLoading();
            })
        },

        async getShipNoList() {
            let params = {
                makerCd: this.$store.state.user.makerCd
            }

            await getShipNoList1(params).then(res => {               
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
            })
        },

        // uppercase() {
        //     this.pntCd = this.pntCd.toUpperCase();
        // }
    },
    mounted() {
        this.getShipNoList()
    }
}
</script>

<style>

</style>